import { createFileRoute } from '@tanstack/react-router';
import { z } from 'zod';
import { AuthLayout } from '@/features/auth/components/auth-layout/AuthLayout';
import { LoginPage } from '@/features/auth/pages/login-page/LoginPage';

const RouteComponent = () => {
  const { redirectUri } = Route.useSearch();
  return (
    <AuthLayout>
      <LoginPage redirectUri={redirectUri} />
    </AuthLayout>
  );
};

export const Route = createFileRoute('/login')({
  validateSearch: z.object({
    redirectUri: z.string().optional(),
  }),
  component: RouteComponent,
});
